import React, { useState } from 'react';
import Menu from '../components/Menu';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';

interface Props {
  menu: any;
}

const DynamicNav = ({ menu }: Props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <Topbar setMobileMenuOpen={setMobileMenuOpen} />
      <Sidebar
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        menu={menu}
      >
        <Menu menu={menu} />
      </Sidebar>
    </>
  );
};

export default DynamicNav;
